<h1 class="app">Wholesale Settings</h1>
<mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)">
  <mat-tab label="COMPANY">
    <lib-company></lib-company>
  </mat-tab>
  <mat-tab label="FEES">
    <lib-fees></lib-fees>
  </mat-tab>
  <mat-tab label="BRANDING">
    <lib-branding></lib-branding>
  </mat-tab>
  <mat-tab label="ADMIN USERS">
    <lib-admin-users></lib-admin-users>
  </mat-tab>
</mat-tab-group>
